module.exports = __webpack_public_path__ + "images/star_small_empty95dbef39b3973b91ce03b9a685ca16a5.svg";